import { call, put, takeEvery } from 'redux-saga/effects';

import * as types from './constants';
import * as actions from './actions';
import { handleErrors, fetch } from '../../../api';
import api from '../../../api/endpoints';

function* editCode({ payload: { id, values, onSuccess, handledErrors } }) {
  try {
    const { data } = yield call(fetch, { api: api.codes.edit, id, data: values });

    onSuccess && onSuccess(data.result);
    yield put(actions.editCodeDone(data.result));
  } catch (error) {
    yield handleErrors({
      error,
      putErrorData: actions.editCodeFailed,
      handledErrors,
      endpoint: api.codes.edit.url
    });
  }
}

export const editCodeSaga = takeEvery(types.EDIT_CODE_REQUEST, editCode);